import { render, staticRenderFns } from "./BacklinksSummary.vue?vue&type=template&id=37128d52&scoped=true&"
import script from "./BacklinksSummary.vue?vue&type=script&lang=js&"
export * from "./BacklinksSummary.vue?vue&type=script&lang=js&"
import style0 from "./BacklinksSummary.vue?vue&type=style&index=0&id=37128d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37128d52",
  null
  
)

/* custom blocks */
import block0 from "./BacklinksSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports